<template>
  <div class="global-loader">
    <div class="loader-content">
      <div class="spinner"></div>
      <p class="message" v-if="message">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    message() {
      return this.$store.state.globalStore.loader.message
    }
  }
}
</script>

<style scoped>
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader-content {
  /* background: white; */
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ffe034;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}
.message {
  color: #fff;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>